// extracted by mini-css-extract-plugin
export default {"input-search":"Input_input-search__6UYaG"};